<template>
  <div class="container-news">
    <div class="news-inner">
      <h2 class="news-title">
        <router-link :to="{ name: $t('newsRouteName'), params: { id: getNewsId } }">
          {{ $t("news") }}
        </router-link>
      </h2>

      <div class="carousel-wrapper">
        <button class="news-btn previous-news-btn" @click="scrollCarousel(-1)">
          <i class="fa fa-chevron-left"></i>
        </button>

        <div class="carousel-view">
          <div id="item-list" class="item-list">
            <div v-for="item in getHighlightedNews" :key="item.id" class="news-article">
              <app-highlighted-news-card :id="item.id"></app-highlighted-news-card>
            </div>
          </div>
        </div>

        <button class="news-btn next-news-btn" @click="scrollCarousel(1)">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
      <press-clipping-carousel :limit="6"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HighlightedServicesCard from './HighlightedNewsCard.vue'
import PressClippingCarousel from './PressClippingCarousel.vue'

export default {
  data() {
    return {
      htmlContent: ""
    }
  },
  computed: {
    ...mapGetters(["getHighlightedNews"]),
    hasHiglightedNews() {
      return this.getHighlightedNews.length > 0;
    },
  },
  components: {
    appHighlightedNewsCard: HighlightedServicesCard,
    PressClippingCarousel
  },
  methods: {
    ...mapActions(["fetchContentById"]),
    loadData() {
      this.fetchContentById(this.id).then((contentResposnse) => {
        this.htmlContent = contentResposnse.content;
      });
    },
    scrollCarousel(direction) {
      const container = this.$el.querySelector("#item-list");
      const element = this.$el.querySelector(".news-article");
      const width = element.getBoundingClientRect().width + 45; // Add gap between items
      container.scrollLeft += direction * width; // Scroll by width of each element
    },
    getNewsId() {
      if (this.getHighlightedNews.length > 0) {
        return this.getHighlightedNews[0].parentId;
      }
      return 0;
    }
  },
  created() {
    this.getNewsId();
  },
  mounted() {
    const prevServicesFirst = this.$el.querySelector('#previous-news-btn');
    const nextServicesFirst = this.$el.querySelector('#next-news-btn');
  },
  watch: {
    content() {
      this.loadData();
    }
  },
}
</script>

<style scoped>
.container-news {
  padding: 3rem 7%;
  width: 100%;
  background-color: var(--secondary-color);
}

.news-inner {
  max-width: 1440px;
  margin: 0 auto;
}

.news-title {
  color: var(--main-color);
  margin-bottom: 2rem;
  font-size: 30px;
  font-weight: 600;
}

.news-title a {
  text-decoration: none;
  color: var(--main-color);
}

.carousel-wrapper {
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
}

.carousel-view {
  flex: 1;
  overflow: hidden;
  padding: 10px 0;
}

.item-list {
  display: flex;
  gap: 24px;
  scroll-behavior: smooth;
  overflow: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.item-list::-webkit-scrollbar {
  display: none;
}

.news-article {
  border-radius: 15px;
  background-color: var(--light-color);
  padding: 1%;
  width: calc((100% - 48px) / 3);
  min-width: calc((100% - 48px) / 3);
  flex-shrink: 0;
}

.news-btn {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: var(--secondary-color);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  color: var(--main-color);
  font-size: 22px;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  padding: 0;
}

.news-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Responsive */
@media (max-width: 1200px) {
  .news-article {
    width: calc((100% - 24px) / 2);
    min-width: calc((100% - 24px) / 2);
  }
}

@media (max-width: 768px) {
  .news-article {
    width: 85%;
    min-width: 85%;
  }
}

@media (max-width: 480px) {
  .news-article {
    width: 100%;
    min-width: 100%;
  }
}
</style>
